import clsx from "clsx"
import React, { PropsWithChildren } from "react"

type Props = {
  isActive: boolean
} & React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>

const TabItem = ({
  isActive,
  className,
  ...props
}: PropsWithChildren<Props>) => {
  return (
    <button
      className={clsx(
        "mr-4 shrink-0 whitespace-nowrap px-0.25 pb-1 pt-0 text-onSurface-500",
        {
          "text-secondary-900 border-b-2 border-secondary-900": isActive,
        },
        className
      )}
      type="button"
      {...props}
    />
  )
}

export default TabItem
